import styled from 'styled-components';
import { isEmpty } from 'utils/lodash.utils';
import SkeletonList from 'components/@client/SkeletonList';
import { MOBILE_TABLET_RESOLUTION } from 'styles/sharedStyle';
import { isFunction } from 'utils/common.utils';
import SkeletonItem from './Items/SkeletonItem';

interface Props<T extends object> {
  EmptyState?: React.FC | JSX.Element;
  items: T[];
  isLoading?: boolean;
  loadingItemCount?: number;
  renderItem: (item: T) => JSX.Element;
}

const MobileCardList = <T extends object>({
  EmptyState = () => <>No items available</>,
  items,
  isLoading = false,
  loadingItemCount = 3,
  renderItem,
}: Props<T>) => {
  return (
    <>
      {isEmpty(items) && !isLoading ? (
        <>{isFunction(EmptyState) ? <EmptyState /> : EmptyState}</>
      ) : (
        <List>
          {isLoading ? (
            <SkeletonList count={loadingItemCount} Item={SkeletonItem} />
          ) : (
            items.map(renderItem)
          )}
        </List>
      )}
    </>
  );
};

export * from './Items';
export * from './EmptyStates';
export default MobileCardList;

const List = styled.ul.attrs({ className: 'card-list' })`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 32px;

  @media ${MOBILE_TABLET_RESOLUTION} {
    font-size: 0.875rem;
    width: 100%;
  }

  & li:last-of-type hr {
    display: none;
  }
`;
